/*
 |--------------------------------------------------------------------------
 | Document Ready Function
 |--------------------------------------------------------------------------
 */

$(function () {
    'use strict';

    $('.btn-play').click((event) => {
        event.preventDefault();

        if ($('#homeVideo').length) {
            controlVideo();
        } else {
            createVideo();
            controlVideo();
        }
    });

    function controlVideo() {
        let homeVideo = $('#homeVideo')[0] || '';
        $('.video-control, .reply').addClass('hidden');

        if (homeVideo.paused) {
            homeVideo.play();
            $('.play').addClass('hidden');
            $(event.currentTarget).addClass('opacity-0 transition duration-500 ease-in-out');
            $(event.currentTarget).removeClass('opacity-100');

            $(event.currentTarget)
                .parent()
                .mouseover((_) => {
                    $(event.currentTarget).addClass('opacity-100');
                    $(event.currentTarget).removeClass('opacity-0');
                });

            $(event.currentTarget)
                .parent()
                .mouseleave((_) => {
                    if ($('.play').hasClass('hidden') && $('.reply').hasClass('hidden')) {
                        $(event.currentTarget).addClass('opacity-0 transition duration-500 ease-in-out');
                        $(event.currentTarget).removeClass('opacity-100');
                    }
                });
        } else {
            homeVideo.pause();
            $('.play').removeClass('hidden');
            $(event.currentTarget).addClass('opacity-100 transition duration-500 ease-in-out');
            $(event.currentTarget).removeClass('opacity-0');

            video.onmouseenter = (e) => {
                video.setAttribute('controls', 'true');
            };
        }
    }

    function createVideo() {
        var video = document.createElement('video'),
            source = document.createElement('source');

        source.setAttribute('src', '/video/home.mp4');
        source.setAttribute('type', 'video/mp4');

        video.setAttribute('id', 'homeVideo');
        video.setAttribute('width', '100%');
        video.setAttribute('class', 'rounded-lg');
        video.setAttribute('playsinline', 'true');
        video.setAttribute('preload', 'none');
        video.setAttribute('controls', 'controls');

        video.appendChild(source);

        $('#divVideoHome').append(video);

        video.onended = (e) => {
            $('.video-control, .reply').removeClass('hidden');
            $('.video-control, .btn-play').removeClass('opacity-0').addClass('opacity-100');
        };
    }
});
